// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { TravelSportComponent } from './travel-sport-component/travel-sport.component';

@NgModule({
  // Declarate the needed components
  declarations: [
    TravelSportComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  // Indicate the modules which will be used in other modules
  ], exports: [
    TravelSportComponent
  ]
})
export class Form2Module { }
